
import { signApi } from '@/api/sign'
import { defineComponent } from 'vue'

export default defineComponent({
  data: () => ({
    send: false,
  }),
  mounted() {
    // eslint-disable-next-line prefer-destructuring
    const eid = this.$route.query.eid
    // eslint-disable-next-line prefer-destructuring
    // const event = this.$route.query.event
    if (eid) {
      signApi.updateMandatStatus(eid as string)
    }
    this.send = true
  },
})
